import { render, staticRenderFns } from "./CategoryBurgerLink.vue?vue&type=template&id=ceedd1ba&scoped=true&"
import script from "./CategoryBurgerLink.vue?vue&type=script&lang=js&"
export * from "./CategoryBurgerLink.vue?vue&type=script&lang=js&"
import style0 from "./CategoryBurgerLink.vue?vue&type=style&index=0&id=ceedd1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceedd1ba",
  null
  
)

export default component.exports